import { render, staticRenderFns } from "./SearchConstructor.vue?vue&type=template&id=52b848e8"
import script from "./SearchConstructor.vue?vue&type=script&lang=js"
export * from "./SearchConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b848e8')) {
      api.createRecord('52b848e8', component.options)
    } else {
      api.reload('52b848e8', component.options)
    }
    module.hot.accept("./SearchConstructor.vue?vue&type=template&id=52b848e8", function () {
      api.rerender('52b848e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search-constructor/SearchConstructor.vue"
export default component.exports